import { Alert, Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, LinearProgress, Slide, TextField, Typography } from "@mui/material";
import { forwardRef, useState } from "react";
import { convertValidMonth, employeeSalary, getDaysInLastMonth, getLastMonth, validMonth } from "./employee_halper";
import DropDownLoading from "../frames/dropdown_loading";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function SalaryPayment({ onClose, open, employee }) {
    const [inputErrors, setInputErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);

    const handleSelfClose = () => {
        if (isLoading) return;
        setInputErrors({});
        setAlertMessage(null);
        onClose();
    }

    const __error_handler = (test, vr, msg) => {
        if (test) {
            inputErrors[vr] = "";
            setInputErrors({ ...inputErrors });
        } else {
            inputErrors[vr] = msg;
            setInputErrors({ ...inputErrors });
        }
        return !test;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (isLoading) return;
        const data = new FormData(event.currentTarget);
        const emp_id = data.get("emp_id");
        const period = convertValidMonth(data.get("period"));
        const amt = Number(data.get("amt"));
        const wd = Number(data.get("wd"));
        console.log(period);

        var flag = true;
        if (__error_handler(Boolean(emp_id), "emp_id", "Select valid employee.")) {
            flag = false;
        }
        if (__error_handler(validMonth(period), "period", "Payment cycle format is MMM-YYYY.")) {
            flag = false;
        }
        if (__error_handler(amt > 0, "amt", "Payment amount zero not possible.")) {
            flag = false;
        }
        if (__error_handler(wd > 0, "wd", "Number of working days greter than zero.")) {
            flag = false;
        }

        if (flag) {
            const _json = { "emp": emp_id, "period": period, "amount": amt, "days": wd };
            setIsLoading(true);
            employeeSalary(_json).then((_) => {
                setIsLoading(false);
                handleSelfClose();
            }).catch((err) => {
                setAlertMessage({ "severity": "error", "message": err.message })
                setIsLoading(false);
            });
        }
    }

    const validateInputs = () => {
        setAlertMessage(null)
        return true;
    }

    return (
        <Dialog open={open} onClose={handleSelfClose} TransitionComponent={Transition} >
            <Box component="form" onSubmit={handleSubmit} noValidate>
                <DialogTitle variant="h5" color="info">Salary Payment</DialogTitle>
                <DialogContent>
                    {alertMessage === null ? "" :
                        <Box sx={{ mt: 2, mb: 2 }}>
                            <Alert severity={alertMessage.severity}>{alertMessage.message}</Alert>
                        </Box>
                    }
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Autocomplete
                                disablePortal
                                noOptionsText={<DropDownLoading title="Loading Clients ..." />}
                                options={employee === null ? [] : employee}
                                getOptionLabel={(option) => String(option.account)}
                                renderOption={(props, option) => {
                                    const { key, ...optionProps } = props;
                                    return (
                                        <Box key={key} component="li" {...optionProps} >
                                            <Typography variant="body2"> {option.name} <Typography variant="caption" component={"span"} color="primary">#{option.account}</Typography></Typography>
                                        </Box>
                                    );
                                }}
                                renderInput={(params) => <TextField {...params} variant="outlined" name="emp_id" fullWidth error={inputErrors.emp_id} type="text" helperText={inputErrors.emp_id} autoFocus placeholder="Employee ID" label="Employee" />}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField variant="outlined" name="period" defaultValue={getLastMonth()} fullWidth error={inputErrors.period} type="month" helperText={inputErrors.period} placeholder="Period" label="Period" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField variant="outlined" name="amt" fullWidth error={inputErrors.amt} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.amt} placeholder="Amount" label="Payment Amount" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField variant="outlined" name="wd" defaultValue={getDaysInLastMonth()} fullWidth error={inputErrors.name} type="number" slotProps={{ htmlInput: { step: 1, min: 0, max: 100 } }} helperText={inputErrors.wd} placeholder="Working Days" label="Working Days" />
                        </Grid>
                    </Grid>
                </DialogContent>
                {isLoading ? <LinearProgress color="secondary" /> : ""}
                <DialogActions>
                    <Button type="submit" variant="contained" fullWidth onClick={validateInputs} color="success">Save</Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
}

export default SalaryPayment;
